import { useEffect } from 'react';

interface Props {
	visible?: () => void;
	hidden?: () => void;
}

export const useVisibilityChange = ({ visible: visibleCb, hidden: hiddenCb }: Props) => {
	const { hidden, visibilityChange } = getHiddenAndVisibilityBrowserSupportedNames();

	useEffect(() => {
		const handleVisibilityChange = () => {
			if (!!document[hidden]) {
				hiddenCb?.();
			} else {
				visibleCb?.();
			}
		};
		const addVisibilityChangeListener = () => {
			document.addEventListener(visibilityChange, handleVisibilityChange, false);
		};
		addVisibilityChangeListener();
		return () => {
			const removeVisibilityChangeListener = () => {
				document.removeEventListener(visibilityChange, handleVisibilityChange, false);
			};
			removeVisibilityChangeListener();
		};
	}, [hidden, hiddenCb, visibilityChange, visibleCb]);
};

type Hidden = 'hidden' | 'msHidden' | 'webkitHidden';
type VisibilityChange = 'visibilitychange' | 'msvisibilitychange' | 'webkitvisibilitychange';

export const getHiddenAndVisibilityBrowserSupportedNames = (): {
	hidden: Hidden;
	visibilityChange: VisibilityChange;
} => {
	// Set the name of the hidden property and the change event for visibility
	let hidden: Hidden = 'hidden';
	let visibilityChange: VisibilityChange = 'visibilitychange';
	if (typeof document.hidden !== 'undefined') {
		// Opera 12.10 and Firefox 18 and later support
		hidden = 'hidden';
		visibilityChange = 'visibilitychange';
	} else if (typeof (document as any).msHidden !== 'undefined') {
		hidden = 'msHidden';
		visibilityChange = 'msvisibilitychange';
	} else if (typeof (document as any).webkitHidden !== 'undefined') {
		hidden = 'webkitHidden';
		visibilityChange = 'webkitvisibilitychange';
	}
	return { hidden, visibilityChange };
};
